export default "__VITE_ASSET__By2sCXO4__"